// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import InternalTableHead from './internal';
function TableHead(props) {
    const baseComponentProps = useBaseComponent('TableHead');
    return React.createElement(InternalTableHead, { ...props, ...baseComponentProps });
}
applyDisplayName(TableHead, 'TableHead');
export default TableHead;
//# sourceMappingURL=index.js.map